/**
 * @generated SignedSource<<20610c48dd13ec4b6f6c407862f01ab0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Answer_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShallowAnswer_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerAddress_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerBudget_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAnswerShouldBeConditionnallyHidden_answer"
    }
  ],
  "type": "AnswerBase",
  "abstractKey": "__isAnswerBase"
};

node.hash = "b31dbe6945e1569c49acf6af41e4fbdf";

module.exports = node;
